import React, { useEffect, useState } from 'react';
import { Form, Select } from 'antd';

import PlaceService from '../../../../../Services/api/PlaceService';

const River = () => {
    const [rivers, setRivers] = useState([]);

    useEffect(() => {
        const getRivers = async () => {
            try {
                const rivers = await PlaceService.getAll();
                setRivers(rivers);
            } catch (error) {
                console.error('Error fetching rivers:', error);
            }
        };
        getRivers();
    }, []);

    return (
        <Form.Item
            label="Rzeka"
            name="placeId"
            rules={[
                {
                    required: true,
                    message: 'Proszę podać rzekę',
                },
            ]}
        >
            <Select showSearch optionFilterProp="children" allowClear>
                {rivers.map((river) => (
                    <Select.Option key={river.id} value={river.id}>
                        {river.name}
                    </Select.Option>
                ))}
            </Select>
        </Form.Item>
    );
};

export default River;
